<template>
  <a-spin :spinning="loading">
    <ul class="s_flex_ali app-warp s_flex_wrap">
      <li class="card s_po_re" v-for="(v,k) in data" :key="k"
        :style="{'background':v.background_map.indexOf('linear-gradient')!==-1 ? v.background_map:('url('+info.picdomain+v.background_map+') center center/cover no-repeat')}">
        <div class="app-user-card">
          <div class="app-card-heard">
            <p>ID：{{v.vip_id}}</p>
            <div>
              <span class="app-card-name">{{info.overView.brand_name}}</span>
              <img :src='info.picdomain+"/"+info.overView.brand_logo' alt="" />
            </div>
          </div>
          <div class="app-card-foot">
            <div class="app-card-foot-left s_flex_ali">
              <img class="m-r-5" 
                :src="v.vip_icon.length == 6 ? require('@/assets/images/user/v'+(v.vip_number+1)+'.png'):info.picdomain+v.vip_icon"
                alt="" />
              <span class="s_cfff fz-14">{{v.vip_name}}</span>
            </div>
            <div class="s_cfff fz-14">成长值：{{v.vip_exp}}</div>
          </div>
        </div>
        <div class="foot">
          <p class="s_c333 p-l-15 p-r-15 s_shou" v-has:userCardLook="()=>lookUser(v)">查看会员</p>
          <div class="s_flex_ali">
            <p class="s_c333 s_shou" v-if='v.del' v-has:userCardDel='()=>del(v)'>删除</p>
            <p class="s_c333 p-l-15 p-r-15 s_shou" v-has:userCardEdit="()=>{$router.push({path:'/members/memberSet/createUserSet',query:{id:v.vip_id,type:'edit'}})}">编辑</p>
          </div>
        </div>
      </li>
      <li class="card createCard s_po_re s_flex_center s_shou"
        v-has:userCardCreate="()=>{$router.push('/members/memberSet/createUserSet?type=add')}" :hidden='data.length >= 8'>
        <PlusOutlined class="fz-46 m-b-30" />
        <p class="height-35 width100 s_flex_center s_po_ab_bl" style="background: #E2E6EA;
        border-radius: 0px 0px 10px 10px;">新增会员卡</p>
      </li>
    </ul>
  </a-spin>
</template>
<script>
  import { PlusOutlined } from "@ant-design/icons-vue";
  import { getMemberVip,delMemberVip } from "@/api/member.js";
  import { ref, toRefs, reactive, onUnmounted, inject } from "vue";
  import { iscode } from "@/utils/app";
  import { message, Modal } from "ant-design-vue";
  import store from "@/store";
  export default {
    components: { PlusOutlined },
    setup() {
      const state = reactive({
        info: store.state.user.info,
        clear: false
      });
      const reg = /#([\da-f]{3}){1,2}/gi;
      const data = ref([]);
      const loading = ref(false);
      const _lodash = inject("_lodash")
      const initData = async () => {
        loading.value = true;
        let res = await getMemberVip().then((res) => res.data);
        loading.value = false;
        if (iscode(res)) {
          data.value = res.data;
          _lodash.last(data.value).del = true
          console.log(data.value)
        }
        loading.value = false;
      };
      initData();
      const lookUser = (e) => {
        state.clear = true;
        $router.push({ path: '/members/memberList', query: { vip_number: e.vip_number } })
      }
      //删除
      const del = (e) => {
        Modal.confirm({
          title: "确定要删除该会员卡么？",
          centered: true,
          content: "会员卡删除后，解除对应会员任务的关联信息",
          onOk: async () => {
            let res = await delMemberVip(e.vip_id).then((res) => res.data);
            if (iscode(res)) {
              message.success(res.msg)
              initData();
            } else {
              message.error(res.msg)
            }
          }
        });
      }
      const $router = inject('$router')
      onUnmounted(() => {
        if (state.clear) {
          $router.push({ query: {} })
        }
      })
      return {
        ...toRefs(state),
        loading,
        data,
        reg,
        lookUser,
        del
      };
    },
  };
</script>
<style lang="less" scoped>
  @import url("@/style/app-warp/app-warp.less");

  .createCard {
    width: 366px;
    background: #F4F6F8;
    border-radius: 10px;
    color: #05486A;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
  }

  .card {
    max-width: 366px;
    height: 172px;
    width: 23%;
    margin-right: 2%;
    margin-bottom: 17px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;

    &:nth-child(4n) {
      margin-right: 0;
    }

    .app-user-card {
      width: 100%;
      height: 100%;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    .foot {

      position: absolute;
      bottom: 1px;
      left: 1px;
      right: 1px;
      height: 35px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 0px 0px 10px 10px;
    }
  }
</style>